"use strict";

/**
 * @generated SignedSource<<b9e4e3765f51a67071d62fe0cce403a4>>
 * @relayHash 9b9662ba6962ed9300d1c4b5dc5e87e5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbfc411946cba076eb97af4ced21eb5b7cff853d784d632f51ac693188e0c05f

const node = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FleetMakeSelect_HomepageQuery",
    "selections": [{
      "alias": null,
      "args": null,
      "concreteType": "VehicleMake",
      "kind": "LinkedField",
      "name": "vehicleMakes",
      "plural": true,
      "selections": [{
        "args": null,
        "kind": "FragmentSpread",
        "name": "VehicleMakeSelect_makes"
      }],
      "storageKey": null
    }],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FleetMakeSelect_HomepageQuery",
    "selections": [{
      "alias": null,
      "args": null,
      "concreteType": "VehicleMake",
      "kind": "LinkedField",
      "name": "vehicleMakes",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPopular",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quoteFunnelConfigToken",
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "params": {
    "id": "bbfc411946cba076eb97af4ced21eb5b7cff853d784d632f51ac693188e0c05f",
    "metadata": {},
    "name": "FleetMakeSelect_HomepageQuery",
    "operationKind": "query",
    "text": null
  }
};
node.hash = "afc955b150f16eb244a352d333fb6961";
export default node;